import React, { useState, useRef } from 'react';

import GridItem from 'components/Grid/GridItem';
import {
  FormControl,
  IconButton,
  MenuItem,
  Select,
  TableCell,
  TableRow,
  TextField,
  Tooltip
} from '@material-ui/core';
import Button from 'components/CustomButtons/Button';

import { WithApp } from 'contexts/appContext';
import TableCrudCustom from './TableCrudCustom';
import { wsFindBy, wsCreate, wsUpdate } from 'services/WService';
import { AccountBalanceWallet, AddShoppingCart, Height, Save } from '@material-ui/icons';
import ConceptModal from './ConceptModal';
import ModalProducts from './Modal/ModalProducts';

const columns = [
  {
    field: 'LineNum',
    edit: false,
    width: 100,
    align: 'center',
    type: 'text',
    title: 'Correlativo'
  },
  {
    field: 'pymt_concept_description',
    edit: false,
    width: 150,
    align: 'center',
    type: null,
    title: 'Concepto'
  },
  { field: 'NumPerMsr', edit: false, width: 100, align: 'center', type: null, title: '# pza' },
  { field: 'BuyUnitMsr', edit: false, width: 150, align: 'center', type: null, title: 'U. Mj' },
  { field: 'UseBaseUn', edit: false, width: 200, align: 'center', type: 'number', title: 'Unidad' },
  {
    field: 'tax_code',
    edit: false,
    width: 200,
    align: 'center',
    type: null,
    title: 'Cód. impto.'
  },
  {
    field: 'last_purchase_price',
    edit: false,
    width: 200,
    align: 'right',
    type: null,
    title: 'Últ. Precio'
  },
  { field: 'ItemCode', edit: false, width: 300, type: 'custom', title: 'Código' },
  { field: 'ItemName', edit: false, width: 700, type: null, title: 'Artículo' },
  { field: 'quantity', edit: true, width: 200, type: 'number', title: 'Cantidad' },
  { field: 'PriceBefDi', edit: true, width: 300, type: 'number', title: 'Precio' },
  { field: 'DiscPrcnt', edit: true, width: 180, type: 'number', title: '% Desc.' },
  { field: 'price', edit: true, width: 300, type: 'number', title: 'Precio con desc.' },
  { field: 'PriceAfVAT', edit: true, width: 250, type: 'number', title: 'P. con IGV' },
  { field: 'VatSum', edit: true, width: 300, type: 'number', title: 'Mont IGV' },
  { field: 'DiscSum', edit: true, width: 350, type: 'number', title: 'Total desc.' },
  { field: 'LineTotal', edit: true, width: 250, type: 'number', title: 'Total línea' },
  { field: 'gtotal', edit: true, width: 250, type: 'number', title: 'Total IGV' },
  { field: 'PriceTypeCode', edit: false, width: 300, type: 'number', title: 'Cód. tipo precio' }
];

const defaultValues = {
  quantity: 0,
  PriceBefDi: 0,
  DiscPrcnt: 0,
  DiscSum: 0,
  price: 0,
  PriceAfVAT: 0,
  VatPrcnt: 0,
  VatSum: 0,
  LineTotal: 0,
  gtotal: 0,
  tax_code: 'IGV'
};

export default WithApp(function InvoiceSubDetail(props) {
  const {
    showNotify,
    id,
    queryType, //indica si es factura manual o proveedor
    taxes,
    purchase,
    purchaseDetails,
    listPurchaseDetails,
    getPurchase,
    getValuesInput,
    unitValue,
    setUnitValue,
    classes,
    stateValidation,
    prorate,
    checkPurchOrder,
    pOrderDetalle,
    reload
  } = props;

  const classRow = useRef(null);
  const codeTax = useRef(null);

  const [open, setOpen] = useState(false);
  const [concept, setConcept] = useState({});
  const [isUpdate, setIsUpdate] = useState({ open: false, id: null });
  const [openModalProducts, setOpenModalProducts] = useState(false);

  /**
   * cambia los valores de cabecera del detalle de acuerdo a queryType ("M" || "P")
   * @returns data modificada por type
   */
  function filterColumns() {
    let dataColumns = columns;
    if (queryType === 'P') {
      dataColumns = columns
        .filter(
          (item) =>
            item.field != 'last_purchase_price' &&
            item.field != 'ItemCode' &&
            item.field != 'UseBaseUn' &&
            item.field != 'BuyUnitMsr' &&
            item.field != 'NumPerMsr'
            // && item.field != 'quantity'
        )
        .map((item) => {
          if (item.field === 'ItemName') {
            item.edit = true;
            item.type = 'text';
            item.field = 'Dscription';
          }
          return item;
        });

    } else if (queryType === 'M') {
      dataColumns = columns
        .filter((item) => item.field != 'pymt_concept_description')
        .map((item) => {
          if (item.field === 'Dscription') {
            item.edit = false;
            item.field = 'ItemName';
          }
          if (item.field === 'BuyUnitMsr') {
            item.field = 'UnitMsr';
          }
          return item;
        });
    }
    return dataColumns;
  }

  function validateFileds(obj) {
    let {
      pymt_account_concept_id,
      logi_product_id,
      PriceTypeCode,
      UseBaseUn,
      tax_code,
      Dscription,
      ...rest
    } = obj;

    for (var key in rest) {
      if (rest[key] == '') {
        rest[key] = 0;
      }
    }
    return rest;
  }

  const [productSelected, setProductSelected] = useState(defaultValues);

  const handleChange = (e) => {
    if (e.target.name == 'UseBaseUn') {
      setUnitValue(e.target.value);
    }
    if (e.target.name == 'PriceAfVAT') {
      let igv = productSelected.VatPrcnt;
      if (queryType === 'P') {
        let codeTaxSelect = codeTax.current.querySelector("input[name='tax_code']").value;
        igv = taxes.find((item) => item.Code == codeTaxSelect).Rate;
      }
      productSelected.PriceBefDi = (parseFloat(e.target.value) * 100) / (100 + parseFloat(igv));
    }
    setProductSelected({
      ...productSelected,
      [e.target.name]: e.target.value
    });
  };

  function calcAmounts() {
    let objCodeTax;
    if (queryType == 'P') {
      let codeTaxSelect = codeTax.current.querySelector("input[name='tax_code']").value;
      objCodeTax = taxes.find((item) => item.Code == codeTaxSelect);
      productSelected.VatPrcnt = parseFloat(objCodeTax.Rate);
      productSelected.tax_code = objCodeTax.Code;
    }
    equalize(productSelected);
  }

  function equalize(selection) {
    let newObj = Object.assign({}, selection); //necesario para procesar los calculos
    let data = {
      //Precio con descuento
      price: parseFloat(newObj.PriceBefDi) * (1 - parseFloat(newObj.DiscPrcnt || 0) / 100) || 0,
      //P. con IGV
      PriceAfVAT:
        parseFloat(newObj.PriceBefDi) *
        (1 - (parseFloat(newObj.DiscPrcnt) || 0) / 100) *
        ((100 + parseFloat(newObj.VatPrcnt)) / 100),
      //monto igv
      VatSum: (
        parseFloat(newObj.quantity) *
          (parseFloat(newObj.PriceBefDi) * (1 - parseFloat(newObj.DiscPrcnt || 0) / 100)) *
          (newObj.VatPrcnt / 100) || 0
      ).toFixed(2),
      //Total descuento
      DiscSum: (
        parseFloat(newObj.quantity) *
          parseFloat(newObj.PriceBefDi) *
          (parseFloat(newObj.DiscPrcnt) / 100) || 0
      ).toFixed(2),
      // total de linea
      LineTotal: (
        parseFloat(newObj.PriceBefDi) *
        (1 - (parseFloat(newObj.DiscPrcnt) || 0) / 100) *
        parseFloat(newObj.quantity)
      ).toFixed(2),
      //monto total
      gtotal: (
        parseFloat(newObj.PriceBefDi) *
        (1 - (parseFloat(newObj.DiscPrcnt) || 0) / 100) *
        parseFloat(newObj.quantity || 0) *
        ((100 + parseFloat(newObj.VatPrcnt)) / 100)
      ).toFixed(2)
    };
    setProductSelected({ ...newObj, ...data });
  }

  async function getProduct(code) {
    let response = await wsFindBy('logi/product', {
      base_business_partner_id: purchase.base_business_partner_id,
      FrgnName: code
    });
    if (response.success && response.data.length > 0) {
      let product = response.data[0];

      setProductSelected({
        ...product,
        price: parseFloat(product.purchase_price),
        PriceBefDi: parseFloat(product.purchase_price),
        VatPrcnt: parseFloat(product.TaxAPRate),
        PriceAfVAT:
          parseFloat(product.purchase_price) +
          (parseFloat(product.purchase_price) * parseFloat(product.TaxAPRate)) / 100,
        UseBaseUn: product.BuyUnitMsr === 'CJA' ? 'N' : product.BuyUnitMsr === 'PZA' ? 'Y' : 'N',
        _unit_msr: 'PZA',
        _NumInBuy: 1
      });
    } else {
      showNotify('No se encontró el artículo', 'info');
      setProductSelected({});
    }
  }

  async function addProduct() {
    if (queryType == 'M') {
      if (!productSelected.id) {
        showNotify('Elija un artículo', 'info');
        return;
      }
    }
    let concatData = {
      ...getValuesInput(classRow),
      ...validateFileds({ ...getValuesInput(classRow) }),
      purch_purchase_id: id
    };
    if (queryType == 'M') {
      concatData.logi_product_id = productSelected.id;
      if (concatData.quantity === '' || concatData.quantity == '0') {
        showNotify('Ingrese una cantidad válida', 'info');
        return;
      }
    }
    if (queryType == 'P') {
      if (Object.keys(concept).length < 1) {
        showNotify('Elija un concepto para este registro', 'info');
        return;
      } else {
        concatData.pymt_account_concept_id = concept.id;
      }
      if (concatData.Dscription === '') {
        showNotify('Ingrese nombre artículo', 'info');
        return;
      }
    }

    if (concatData.PriceBefDi == '' || concatData.PriceBefDi == '0') {
      showNotify('Ingrese precio válido', 'info');
      return;
    }

    /* console.log('no pasa', concatData);
    return; */
    let response = await wsCreate('purch/purchase-detail', concatData);
    if (response.success) {
      showNotify(response.message);
      setConcept({});
      setProductSelected(defaultValues);
      listPurchaseDetails(id);
      getPurchase();
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function saveRow(idRow, data) {
    let response = await wsUpdate('purch/purchase-detail', idRow, data);
    if (response.success) {
      showNotify(response.message);
      setIsUpdate({ open: false, id: null });
      listPurchaseDetails(id);
      getPurchase();
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <>
      <ConceptModal
        setConcept={setConcept}
        open={open}
        setOpen={setOpen}
        isUpdate={isUpdate}
        saveRow={saveRow}
        purchase={purchase}
      />
                        
      {openModalProducts && (
        <ModalProducts
          open={openModalProducts} 
          onClose={() => 
            setOpenModalProducts(false)
          }
          showNotify={showNotify}
          ordersProducts= {pOrderDetalle}
          purchProducts= {purchaseDetails}
          purchOrderId={purchase.purch_order_id}
          purchaseId={purchase.id}
          reload={reload}
          />
      )}

      <GridItem xs={12}>
        <TableCrudCustom
          minWidth={queryType == 'M' ? 2700 : 2350}
          columns={filterColumns()}
          listDetails={purchaseDetails}
          saveItemRow={saveRow}
          deleteDetailEntity="purch/purchase-detail"
          reloadDetail={() => {
            getPurchase();
            listPurchaseDetails(id);
          }}
          closeEditCell={stateValidation} //true or false
          setOpen={setOpen}
          type={queryType}
          setIsUpdate={setIsUpdate}
        >
          {!stateValidation ? (
            <TableRow ref={classRow} key={purchaseDetails}>
              <TableCell align="center">
                {queryType == 'P' ? (
                  <Tooltip title="Concepto" placement="right">
                    <IconButton aria-label="delete" color="secondary" onClick={() => setOpen(true)}>
                      <AccountBalanceWallet />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <AddShoppingCart style={{ color: '#4caf50' }} />
                )}
              </TableCell>
              <TableCell align="center">
                <Height style={{ color: '#4caf50' }} />
              </TableCell>
              {queryType == 'P' ? (
                <TableCell align="center">{concept.pymt_concept_description || '-'}</TableCell>
              ) : undefined}
              {queryType == 'M' ? (
                <>
                  <TableCell align="center">
                    {unitValue === 'Y'
                      ? productSelected._NumInBuy
                      : parseInt(productSelected.NumInBuy || 0)}
                  </TableCell>
                  <TableCell align="center">
                    {unitValue === 'Y' ? productSelected._unit_msr : productSelected.BuyUnitMsr}
                  </TableCell>

                  <TableCell>
                    <FormControl fullWidth margin="normal" size="small">
                      <Select
                        //disabled={unitLocked}
                        value={unitValue}
                        inputProps={{
                          name: 'UseBaseUn',
                        }}
                        onChange={handleChange}
                      >
                        <MenuItem value="Y">Si</MenuItem>
                        <MenuItem value="N">No</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                </>
              ) : undefined}

              {queryType == 'P' ? (
                <TableCell align="center">
                  <FormControl fullWidth margin="normal" size="small">
                    <Select
                      ref={codeTax}
                      defaultValue="IGV"
                      inputProps={{
                        name: 'tax_code',
                      }}
                      onChange={handleChange}
                      onBlur={calcAmounts}
                    >
                      {taxes.map((item) => (
                        <MenuItem key={item.id} value={item.Code}>
                          {`${item.Code} - (${parseFloat(item.Rate).toFixed(2)}%)`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
              ) : (
                <TableCell align="center">
                  {!!productSelected.TaxCodeAP
                    ? `${productSelected.TaxCodeAP} - ${(
                        parseFloat(productSelected.TaxAPRate) || 0
                      ).toFixed(2)}%`
                    : ''}
                </TableCell>
              )}

              {queryType == 'M' ? (
                <TableCell align="right">{productSelected.last_purchase_price_um}</TableCell>
              ) : undefined}

              {queryType == 'M' ? (
                <>
                  <TableCell>
                    <TextField
                      defaultValue=""
                      placeholder="Pegar código"
                      title="Mínimo 2 caracteres"
                      size="small"
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' && e.target.value.length > 1) {
                          getProduct(e.target.value);
                        } else {
                          setProductSelected({});
                        }
                      }}
                    />
                  </TableCell>
                  <TableCell>{productSelected.ItemName}</TableCell>
                </>
              ) : queryType == 'P' ? (
                <TableCell>
                  <TextField
                    name="Dscription"
                    defaultValue=""
                    size="small"
                    fullWidth
                    onChange={handleChange}
                  />
                </TableCell>
              ) : undefined}

              {/* {queryType == 'M' ? ( */}
              <TableCell>
                <TextField
                  name="quantity"
                  defaultValue="0"
                  inputProps={{ min: 0, step: 0.001 }}
                  size="small"
                  type="number"
                  onChange={handleChange}
                  onBlur={calcAmounts}
                />
              </TableCell>
              {/* ) : undefined} */}

              <TableCell>
                <TextField
                  value={parseFloat(parseFloat(productSelected.PriceBefDi || 0).toFixed(4)) || ''} // precio sin igv
                  name="PriceBefDi"
                  inputProps={{ min: 0.01, step: 0.01 }}
                  size="small"
                  type="number"
                  onChange={handleChange}
                  onBlur={calcAmounts}
                />
              </TableCell>
              <TableCell>
                <TextField
                  name="DiscPrcnt"
                  value={productSelected.DiscPrcnt || ''}
                  inputProps={{ min: 0.01, step: 0.01 }} // % de descuento
                  size="small"
                  type="number"
                  onChange={handleChange}
                  onKeyUp={(e) => {
                    if (e.target.value > 100) {
                      setProductSelected({
                        ...productSelected,
                        DiscPrcnt: 100,
                      });
                    }
                  }}
                  onBlur={calcAmounts}
                />
              </TableCell>
              <TableCell>
                <TextField
                  name="price"
                  value={parseFloat(parseFloat(productSelected.price || 0).toFixed(4)) || ''} // precio con descuento
                  inputProps={{ min: 0, step: 0.01 }}
                  size="small"
                  type="number"
                  onChange={handleChange}
                  onBlur={calcAmounts}
                />
              </TableCell>
              <TableCell>
                <TextField
                  value={parseFloat(parseFloat(productSelected.PriceAfVAT || 0).toFixed(4)) || ''} //precio con igv
                  name="PriceAfVAT"
                  inputProps={{ min: 0, step: 0.01 }}
                  size="small"
                  type="number"
                  onChange={handleChange}
                  onBlur={calcAmounts}
                />
              </TableCell>
              <TableCell>
                <TextField
                  name="VatSum"
                  value={productSelected.VatSum || ''} //monto con IGV
                  inputProps={{ min: 0.01, step: 0.01 }}
                  size="small"
                  type="number"
                  onChange={handleChange}
                />
              </TableCell>
              <TableCell>
                <TextField
                  name="DiscSum"
                  value={productSelected.DiscSum || ''}
                  inputProps={{ min: 0.01, step: 0.01 }}
                  size="small"
                  type="number"
                  onChange={handleChange}
                />
              </TableCell>
              <TableCell>
                <TextField
                  name="LineTotal"
                  value={productSelected.LineTotal || 0}
                  inputProps={{ min: 0.01, step: 0.01 }}
                  size="small"
                  type="number"
                  onChange={handleChange}
                />
              </TableCell>
              <TableCell>
                <TextField
                  name="gtotal"
                  value={productSelected.gtotal || 0}
                  inputProps={{ min: 0.01, step: 0.01 }}
                  size="small"
                  type="number"
                  onChange={handleChange}
                />
              </TableCell>
              <TableCell>
                <FormControl fullWidth margin="normal" size="small">
                  <Select
                    defaultValue="01"
                    inputProps={{
                      name: 'PriceTypeCode',
                    }}
                    onChange={handleChange}
                  >
                    <MenuItem value="01">P/U (Incluye IGV)</MenuItem>
                    <MenuItem value="02">Valor ref. uni. en oper. no onerosas</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell>
                <Button
                  type="submit"
                  justIcon
                  round
                  simple
                  color={props.themeContext.buttonColorSuccess}
                  onClick={addProduct}
                >
                  <Save />
                </Button>
              </TableCell>
            </TableRow>
          ) : undefined}
        </TableCrudCustom>
      </GridItem>

      <GridItem xs={12}>
        <Button
          type="button"
          color={props.themeContext.buttonColorSuccess}
          className={classes.marginRight}
          onClick={() => {
            window.history.replaceState(
              null,
              null,
              `/admin/compras/operaciones/${
                queryType === 'M' ? 'factura' : 'factura-proveedores'
              }/0?type=${queryType}`,
            );
            window.location.reload();
          }}
        >
          Nuevo Registro
        </Button>
        <Button
          type="button"
          color={props.themeContext.buttonColorWarning}
          className={classes.marginRight}
          style={{ marginRight: '15px' }}
          onClick={() => {
            prorate();
          }}
          disabled={stateValidation || purchaseDetails.length < 1}
        >
          prorratear
        </Button>
        <Button
          type="button"
          color={props.themeContext.buttonColor}
          className={classes.marginRight}
          style={{ marginRight: '15px' }}
          onClick={() => {
            listPurchaseDetails(id, true, { proc_status: 'V' });
          }}
          disabled={stateValidation || purchaseDetails.length < 1}
        >
          Validar Factura
        </Button>
        {purchase.proc_status == 'V' ? (
            <Button
              type="button"
              color={props.themeContext.buttonColorInfo}
              className={classes.marginRight}
              style={{ marginRight: '15px' }}
              onClick={() => {
                listPurchaseDetails(id, true, { proc_status: 'X', checkPurchOrder: checkPurchOrder ? 1 : 0 });
              }}
              disabled={purchase.proc_status !== 'V'}
              >
            Actualizar estado
          </Button>
        ) : undefined}
        {purchase.proc_status == 'V' && checkPurchOrder ? (
          <Button
          color={props.themeContext.buttonColorDanger}
          className={classes.marginRight}
          style={{ marginRight: '15px' }}
          onClick={() => setOpenModalProducts(true)}
          disabled={ purchase.validate_purch_order_at !== null || !pOrderDetalle || pOrderDetalle.length === 0 }
          >
            Validación de orden de compra
          </Button>
        ) : undefined}
      </GridItem>
    </>
  );
});
